const routes = [{
        path: '/',
        name: 'Client',
        component: () => import("@/views/Client/master.vue"),
        redirect: "/login",
    },
    {
        path: '/login',
        name: 'Login',
        hideSearch: true,
        component: () => import("@/views/Auth/Logins/login.vue"),
    },
    {
        path: '/panel',
        name: 'Panel',
        hideSearch: true,
        component: () => import("@/layout/panel.vue"),
        children: [{
                path: "/dashboard",
                name: "Dashboard",
                component: () => import("@/views/Dashboard/dashboard.vue"),
                meta: {
                    title: "داشبورد",
                },
            },
            {
                path: "/categories",
                name: "list_category",
                component: () => import("@/views/Category/list.vue"),
                meta: {
                    title: "دسته بندی ها",
                },
            },
            {
                path: "/category/add",
                name: "add_category",
                component: () => import("@/views/Category/CE.vue"),
                meta: {
                    title: "افزودن دسته بندی",
                },
            },
            {
                path: "/category/edit/:category_id",
                props: true,
                name: "edit_category",
                component: () => import("@/views/Category/CE.vue"),
                meta: {
                    title: "ویرایش دسته بندی",
                },
            },
            {
                path: "/sliders",
                name: "list_slider",
                component: () => import("@/views/Slider/list.vue"),
                meta: {
                    title: "اسلایدر ها",
                },
            },
            {
                path: "/slider/add",
                name: "add_slider",
                component: () => import("@/views/Slider/CE.vue"),
                meta: {
                    title: "افزودن اسلایدر",
                },
            },
            {
                path: "/slider/edit/:slider_id",
                props: true,
                name: "edit_slider",
                component: () => import("@/views/Slider/CE.vue"),
                meta: {
                    title: "ویرایش اسلایدر",
                },
            },
            {
                path: "/products",
                name: "list_product",
                component: () => import("@/views/Product/list.vue"),
                meta: {
                    title: "محصولات",
                },
            },
            {
                path: "/product/add",
                name: "add_product",
                component: () => import("@/views/Product/CE.vue"),
                meta: {
                    title: "افزودن محصول",
                },
            },
            {
                path: "/product/edit/:product_id",
                props: true,
                name: "edit_product",
                component: () => import("@/views/Product/CE.vue"),
                meta: {
                    title: "ویرایش محصول",
                },
            },
            {
                path: "/posts",
                name: "list_post",
                component: () => import("@/views/Post/list.vue"),
                meta: {
                    title: "وبلاگ",
                },
            },
            {
                path: "/post/add",
                name: "add_post",
                component: () => import("@/views/Post/CE.vue"),
                meta: {
                    title: "افزودن پست",
                },
            },
            {
                path: "/post/edit/:post_id",
                props: true,
                name: "edit_post",
                component: () => import("@/views/Post/CE.vue"),
                meta: {
                    title: "ویرایش پست",
                },
            },
            {
                path: "/cook",
                name: "list_cook",
                component: () => import("@/views/Cook/list.vue"),
                meta: {
                    title: "مستند",
                },
            },
            {
                path: "/cook/add",
                name: "add_cook",
                component: () => import("@/views/Cook/CE.vue"),
                meta: {
                    title: "افزودن مستند",
                },
            },
            {
                path: "/cook/edit/:cook_id",
                props: true,
                name: "edit_cook",
                component: () => import("@/views/Cook/CE.vue"),
                meta: {
                    title: "ویرایش مستند",
                },
            }
        ]
    }

]

export default routes;
